module.exports = __webpack_public_path__ + "assets/CheckPoint.74965668.svg";